import { isBefore, parseISO, startOfMonth, isEqual } from 'date-fns'

export const INVOICE_ACTIVITY_TABS_ID = {
  PAYMENT_TAB_ID: 'Payment',
  EMAIL_TAB_ID: 'Email',
  POSTING_TAB_ID: 'Posting',
}

export const filterBillingPeriods = (allBillingPeriods, includeLateFees, isLateFeeEnabled) => {
  if (includeLateFees && isLateFeeEnabled) {
    const currentMonthStart = startOfMonth(new Date())
    return allBillingPeriods.filter(period => {
      const invoiceDate = parseISO(period.invoiceDate)
      return !isBefore(invoiceDate, currentMonthStart)
    })
  }
  return allBillingPeriods
}

export const mapBillingPeriods = (allBillingPeriods, includeLateFees, isLateFeeEnabled) => {
  const currentMonthStart = startOfMonth(new Date())

  return allBillingPeriods.map(period => {
    const invoiceDate = parseISO(period.invoiceDate)
    const isLockedLateFeeRelated = includeLateFees && isLateFeeEnabled ? isBefore(invoiceDate, currentMonthStart) : false
    return { ...period, isLockedLateFeeRelated }
  })
}

export const isValidLateFeeInvoiceDate = date => {
  const currentMonthStart = startOfMonth(new Date())
  const inputDate = parseISO(date)

  return !isBefore(inputDate, currentMonthStart)
}

export const getIsSelectedPeriodDateValidForLateFees = (selectedPeriodDate, filteredBillingPeriods) => {
  return filteredBillingPeriods.some(period => isEqual(parseISO(period.invoiceDate), parseISO(selectedPeriodDate)))
}
